import { useMemo } from 'react';
import { generateRandomString } from '../helpers/StringHelpers';

export const useRandomString = (len: number = 20) => {
  return useMemo(() => { return generateRandomString(len) }, [len]);
};
